import fp from 'micro-fp';

export default function objectAsArray() {
  return fp.values;
}
